import { all, takeEvery, select, call, put } from "@redux-saga/core/effects";
import actionTypes from "../actions/actionTypes";
import { subscriptionBaseUrl, httpClient } from "../../http-client/http-client";
import { subscriptionActions } from '../actions/subscription/subscription';

const accessTokenSelector = (state) => state.oidc.user.access_token;

function* fetchInfo(action) {
  const accessToken = yield select(accessTokenSelector);
  const url = `${subscriptionBaseUrl}`;

  try {
    const data = yield call(httpClient.get, url, accessToken);
    yield put(subscriptionActions.fetchInfoOk(data));
  }
  catch(error){
    yield put(subscriptionActions.fetchInfoError(error));
  }
}

export function* watchSubscription() {
  yield all([
    takeEvery(actionTypes.subscription.FETCH_INFO, fetchInfo),
  ]);
}